import { useState } from 'react'
import { SUBSCRIPTION_PRICE_A_MONTH } from '../../constants'
import Sundial from './Sundial'
import GoalsShot from './shots/GoalsShot'

const Hero = () => {
    const [date, setDate] = useState(() => new Date())

    return (
        <section className="hero" id="hero">
            <div className="backdrop" aria-hidden="true">
                <div className="backdrop__wash" />
                <div className="blob blob--yellow" />
                <div className="blob blob--amber" />
                <div className="blob blob--pink" />
                <div className="blob blob--sky" />
                <div className="backdrop__fade" />
            </div>
            <Sundial onDateChange={setDate} />
            <div className="gt-container hero__inner">
                <div className="hero__copy">
                    <h1 data-stagger>Tasks are cheap. Time is not.</h1>
                    <p className="hero__sub" data-stagger>
                        General Task connects tasks, goals, and Google Calendar so scheduled work counts toward the
                        goal. Only {SUBSCRIPTION_PRICE_A_MONTH}.
                    </p>
                </div>
                <div className="hero__shot" data-stagger>
                    <GoalsShot date={date} />
                </div>
            </div>
        </section>
    )
}

export default Hero
